import BackendService from "../../../backend/controller/BackendService";
import PlayerModel from "../../../player/model/PlayerModel";
import ConversationReflection from "../../model/ConversationReflection";

export default class ConversationReflectionState extends createjs.EventDispatcher {
    /**
     * @param {string} chapterId
     * @param {ConversationReflection} conversation 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationReflectionState>} successor state.
     */
    async execute(chapterId, conversation, backendService, playerModel) {
        throw `ConversationReflectionState.enter must be implemented by subclass`;
    }

    async reset() {

    }

    /**
     * @param {string} message 
     */
    handlePlayerInput(message) {
        console.warn(`ConversationReflectionState.handlePlayerInput not implemented by subclass. Ignoring message: '${message}'.`);
    }

    destroy() {
        this.removeAllEventListeners();
    }
}

ConversationReflectionState.SAVE_SNAPSHOT = 'ConversationReflectionState.SAVE_SNAPSHOT';